(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function updateStartingFromPrices() {
    document.querySelectorAll('.product-grid__item[data-starting-price]').forEach((item) => {
      const startingPrice = item.dataset.startingPrice;
      if (!startingPrice) return;

      const priceElement =
        item.querySelector('.price') ||
        item.querySelector('.product-card__price') ||
        item.querySelector('.card-information .price') ||
        item.querySelector('[class*="price"]');

      if (priceElement && !priceElement.dataset.startingPriceUpdated) {
        priceElement.innerHTML = `<span class="starting-from-price">Starting from ${startingPrice}</span>`;
        priceElement.dataset.startingPriceUpdated = 'true';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', updateStartingFromPrices);

  const observer = new MutationObserver(updateStartingFromPrices);

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
